import { xyEnsureGrowingX } from 'ml-spectra-processing';
/**
 * Ensure X values are strictly monotonic increasing
 * https://www-groups.mcs.st-andrews.ac.uk/~john/analysis/Lectures/L8.html
 * @param data
 */
export function ensureGrowing(data) {
    return { data: xyEnsureGrowingX(data) };
}
//# sourceMappingURL=ensureGrowing.js.map